"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HeaderMobile = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MobileTopContent = _interopRequireDefault(require("./MobileTopContent"));
var _MobileBottomContent = _interopRequireDefault(require("./MobileBottomContent"));
var _headerContext = require("./headerContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HeaderMobile = _ref => {
  let {
    username,
    email,
    onClickHome,
    onClickCategories,
    menuItems,
    searchPlaceHolder,
    searchCallback,
    hiddenMenu,
    logo,
    logoImg,
    navigateMenu,
    drawerItems,
    hasCategories,
    isFullHeight
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_headerContext.HeaderProvider, null, /*#__PURE__*/_react.default.createElement(_MobileTopContent.default, {
    username: username,
    email: email,
    onClickHome: onClickHome,
    menuItems: menuItems,
    searchCallback: searchCallback,
    searchPlaceHolder: searchPlaceHolder,
    hiddenMenu: hiddenMenu,
    logo: logo,
    logoImg: logoImg,
    navigateMenu: navigateMenu,
    drawerItems: drawerItems,
    hasCategories: hasCategories,
    isFullHeight: isFullHeight
  }), /*#__PURE__*/_react.default.createElement(_MobileBottomContent.default, {
    onClickCategories: onClickCategories,
    hasCategories: hasCategories,
    onClickHome: onClickHome
  }));
};
exports.HeaderMobile = HeaderMobile;
HeaderMobile.propTypes = {
  /**
   * Nome do usuário exibido ao clicar no menu
   */
  username: _propTypes.default.string,
  /**
   * Email do usuário exibido ao clicar no menu
   */
  email: _propTypes.default.string,
  /**
   * Função requerida para quando o usuário clicar em uma das opções do menu
   */
  onClickHome: _propTypes.default.func.isRequired,
  /**
   * Lista de objetos que serão concatenados ao menu (aberto ao clicar no avatar).
   */
  menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    nodeIcon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }).isRequired).isRequired,
  /**
   * Lista de objetos que serão concatenados na drawer (aberto ao clicar no menu hamburguer).
   */
  drawerItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    nodeIcon: _propTypes.default.node,
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  }).isRequired),
  /**
   * Mensagem que aparecerá como placeholder da barra de pesquisa
   */
  searchPlaceHolder: _propTypes.default.string,
  /**
   * Função requerida para quando a pessoa realizar a pesquisa (apertar o Enter).
   * Receberá como parâmetro o termo que está na barra de pesquisa
   */
  searchCallback: _propTypes.default.func.isRequired,
  hiddenMenu: _propTypes.default.bool,
  /**
   * Logo que aparecerá no topo da página.
   */
  logo: _propTypes.default.element,
  /**
   * Logo que aparecerá no topo da página caso seja passado uma tag de imagem.
   */
  logoImg: _propTypes.default.node,
  /**
   * Se `TRUE`, habilita o menu sanduiche na versao mobile
   */
  navigateMenu: _propTypes.default.bool,
  /**
   * Se 'TRUE', a bottom navigation apresenta o botao de categorias
   */
  hasCategories: _propTypes.default.bool,
  /**
   * Função requerida para quando o usuário clicar no botao de categorias da bottom navigation
   */
  onClickCategories: _propTypes.default.func.isRequired,
  /**
   * Se True, deixa a altura dos menuItems como auto
   */

  isFullHeight: _propTypes.default.bool
};
HeaderMobile.defaultProps = {
  email: 'email@somoseducacao.com.br',
  username: 'Saraiva Educacao',
  searchPlaceHolder: 'Buscar...',
  hiddenMenu: false,
  navigateMenu: false,
  drawerItems: null,
  logo: null,
  logoImg: null,
  hasCategories: false,
  isFullHeight: false
};
var _default = exports.default = HeaderMobile;